export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/prestashop.f4e84df.svg";